import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { RootContext } from "@-/dev.improve.haniverse.routes._context";
import {
  LearnFlashcardSurfaceReadyMarker,
  useLearnCardSurface,
} from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";
import { LessonPageLandscapeView } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._views.landscape";
import { LessonPagePortraitView } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._views.portrait";

/** The "New Character" front as a deck card face: level preview above the centered glyph. */
export function LessonFlashcardFront() {
  const [orientation] = useContextSelectors(RootContext, (c) => c.orientation);
  const { isActive } = useLearnCardSurface();
  return (
    <>
      {orientation === "landscape" ? (
        <LessonPageLandscapeView isActive={isActive} />
      ) : (
        <LessonPagePortraitView isActive={isActive} />
      )}
      <LearnFlashcardSurfaceReadyMarker />
    </>
  );
}
